import { SpectrogramDouble } from '../src/specgram_double'
import { TimePlot } from '../src/timeplot'
import { App, DataSource } from '../src/data_source'

const WIN_SIZE_SEC = 5;
const Fs = 472;
const NFFT = 64;
const OVERLAP = 56;

let plots = [];

for (let i = 0; i < 9; i++){
  let spec: SpectrogramDouble = new SpectrogramDouble("spec_"+i, document.getElementById("spec_"+i), Math.floor(WIN_SIZE_SEC*Fs/(NFFT-OVERLAP)), NFFT/2+1, Fs/2, 5e-10, 1e-7, {title: "Channel " + i});
  plots.push(spec);
}
const timeplot: TimePlot = new TimePlot("data", document.getElementById("timeplot"), 9, WIN_SIZE_SEC * Fs, [0, 1], {title: "Raw signals", yLabel: "Voltage (V)"});
const timeplot2: TimePlot = new TimePlot("energy", document.getElementById("energy"), 2, WIN_SIZE_SEC * Fs, [0, 5e-1], {title: "Raw and filtered energy", yLabel: "Signal energy", labels: ["Raw", "Filtered"]});
plots.push(timeplot);
plots.push(timeplot2);

const source = new DataSource();

const app = new App();
app.run(source, plots)
